import { Store } from "lucide-react";
import { motion } from "framer-motion";

const MerchantNumber = ({
  numberOfMerchants,
  isLoading,
}: {
  numberOfMerchants: number;
  isLoading: boolean;
}) => {
  if (isLoading) {
    return (
      <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow duration-200 w-fit min-w-[200px]">
        <div className="flex flex-col items-center text-center space-y-3">
          <div className="flex items-center justify-center w-12 h-12 bg-blue-50 rounded-full">
            <motion.div
              animate={{ rotate: 360 }}
              transition={{
                duration: 2,
                repeat: Number.POSITIVE_INFINITY,
                ease: "linear",
              }}
            >
              <Store className="w-6 h-6 text-blue-600" />
            </motion.div>
          </div>
          <div className="space-y-1">
            <div className="text-3xl font-bold text-gray-900 h-9 flex items-center justify-center">
              <motion.div className="flex space-x-1">
                {[0, 1, 2].map((i) => (
                  <motion.div
                    key={i}
                    className="w-2 h-2 bg-blue-600 rounded-full"
                    animate={{
                      scale: [1, 1.5, 1],
                      opacity: [0.3, 1, 0.3],
                    }}
                    transition={{
                      duration: 1.5,
                      repeat: Number.POSITIVE_INFINITY,
                      delay: i * 0.2,
                      ease: "easeInOut",
                    }}
                  />
                ))}
              </motion.div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-white rounded-xl border border-gray-200 p-6 shadow-sm hover:shadow-md transition-shadow duration-200 w-fit min-w-[200px]">
      <div className="flex flex-col items-center text-center space-y-3">
        <div className="flex items-center justify-center w-12 h-12 bg-blue-50 rounded-full">
          <Store className="w-6 h-6 text-blue-600" />
        </div>
        <div className="space-y-1">
          <motion.div
            className="text-3xl font-bold text-gray-900"
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            {numberOfMerchants.toLocaleString()}
          </motion.div>
          <div className="text-sm font-medium text-gray-500 uppercase tracking-wide">
            {numberOfMerchants === 1 ? "Merchant" : "Merchants"}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MerchantNumber;
